import { Stack, styled } from "@mui/material";

export const CustomerApprovalActionWrapper = styled(Stack)(() => {
    return {
        gap: "var(--flex-gap)",
        "& .MuiCard-root": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
        },
        "& .card-content": {
            padding: "0",
            display: "flex",
            flexDirection: "column",
            height: "100%",
        },
        "& .profile-information, & .account-number, & .account-tier, & .supporting-documents, & .application-information": {
            padding: "var(--basic-padding)",
        },
        "& .profile-information:last-child, & .account-number:last-child, & .account-tier:last-child, & .application-information:last-child, & .supporting-documents": {
            paddingBottom: "var(--basic-padding)",
        },
        "& .account-number, & .account-tier": {
            justifyContent: "center",
        },
        "& fieldset": {
            display: "flex",
            alignItems: "center",
            gap: "calc(var(--flex-gap) / 2)",
            justifyContent: "space-between",
            overflow: "hidden",
        },
    }
})